import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "addSwiper",
  data: function data() {
    return {
      form: {
        id: "",
        name: "",
        qr_code: "",
        hide_img: "",
        show_img: "",
        url: "",
        platform_type: "",
        is_open: "",
        language: ""
      },
      dialogShow: false,
      qr_code: [],
      hide_img: [],
      show_img: [],
      rules: {
        // sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        name: [{
          required: true,
          message: "请输入名字",
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        // url: [{ required: true, message: "请输入链接", trigger: "blur" }],
        // hide_img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        show_img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }],
        is_open: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        platform_type: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = _objectSpread({}, data);
                  _this['qr_code'] = data.qr_code ? [data.qr_code] : [];
                  _this['hide_img'] = data.hide_img ? [data.hide_img] : [];
                  _this['show_img'] = data.show_img ? [data.show_img] : [];
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e, type) {
      this[type] = e;
      this.form[type] = e[0] && e[0].response ? e[0].response.data : '';
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        name: "",
        qr_code: "",
        hide_img: "",
        show_img: "",
        url: "",
        is_open: "",
        language: "",
        platform_type: ""
      };
      this.qr_code = [], this.hide_img = [], this.show_img = [], this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = _this2.form.id ? 'downloadLinkUpdate' : 'downLoadLinkAdd';

          _this2.$api[reqFn](_this2.form).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};